import React from "react";
import ReactGA from "react-ga";
import _ from "lodash";
import { getCurrentPage, trackLinkClick } from "../helpers";
import { Link } from "react-scroll";

import Locations from "./Locations";
import ErrorList from "./ErrorList";
import Footer from "./Footer";
import MapWrapper from "./MapWrapper";
import infoIcon from "../images/information.png";

class PlanningForm extends React.Component {
  state = {
    loading: false,
    valid: false,
    isTabletOrSmaller: false,
  };

  checkValid = () => {
    const { locations } = this.props;

    const valid_locations = _.filter(
      locations,
      (location) => location.lat && location.lng
    );

    const valid = valid_locations.length >= 2;

    this.setState({valid});
    return valid;
  };

  handleSubmit = _.debounce(() => {
    // GA Track
    ReactGA.event({
      category: _.startCase(getCurrentPage()),
      action: "Click Get Directions",
    });

    // Remove empty form fields
    this.props.clearEmptyLocations();

    const valid = this.checkValid();

    const { locations } = this.props;

    if (valid) {
      this.setState({
        loading: true,
      });

      this.props.getjourneys(locations);
    } else {
      this.props.addError("Select at least two locations", "routePlanning");

      locations.forEach((location, i) => {
        if (!location.lat || !location.lng) {
          this.props.addError(
            "Select a location or geolocation",
            `locations_${i}`
          );
        }
      });
    }
  }, 200);

  removeOverlay = () => {
    this.props.map.overlays.sitewide 
    && this.props.map.overlays.sitewide.length > 0
    && this.props.removeOverlay();
  }

  componentDidMount() {
    this.checkValid();
    this.mediaQuery = window.matchMedia("(max-width: 1000px)");
    this.handleMediaQueryChange(this.mediaQuery);
    this.mediaQuery.addEventListener("change", this.handleMediaQueryChange);
  }

  componentDidUpdate(prevProps) {
    // New locations
    const newLocations = !_.isEqual(this.props.locations, prevProps.locations);
    if (newLocations) {
      this.checkValid();
    }

    // New errors
    const newErrors = !_.isEqual(
      this.props.errors.routePlanning,
      prevProps.errors.routePlanning
    );
    if (newErrors) {
      this.setState({
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    this.mediaQuery.removeEventListener("change", this.handleMediaQueryChange);
  }

  handleMediaQueryChange = (event) => {
    this.setState({ isTabletOrSmaller: event.matches });
  };

  render() {
    const formClasses = this.state.loading
      ? "planning-form loading"
      : "planning-form";
    const buttonText = this.state.loading ? "Loading" : "Get Directions";
    const { isTabletOrSmaller } = this.state;
    let valid = this.state.valid

    return (
      <div className="planning-form-wrapper sidebar-content-vertical-container">
        <header className="planning-form-header">
          <h1 className="main-title">Route Planner</h1>
          <h2 className="sub-title">Cycling in the West of England</h2>
          <p>
            Discover the shortest, safest, cycle routes to get you where you
            want to go.{" "}
          </p>
          <p className="tagline">Cheaper, faster, healthier and BETTER!</p>
        </header>

        <form
          ref="planningForm"
          className={formClasses}
          aria-label="Plan a trip"
          onSubmit={(e) => {
            e.preventDefault();
            this.handleSubmit();
          }}
          onMouseOver={ this.removeOverlay }
        >
          <svg className="tab-illustration">
            <use xlinkHref="#ill-route-planner" />
          </svg>

          <h2 className="sub-title">Plan a Trip</h2>
          {isTabletOrSmaller && (
            <p className="planning-form-instructions">
              Add your start and end locations using the fields below. Or, use the{" "}
              <Link
                activeClass="active"
                to="planning-form-map"
                spy={true}
                smooth={true}
                offset={-69}
                duration={500}
              >
                map
              </Link>{" "}
              to select your start and end locations.
            </p>
          )}

          <Locations {...this.props} />

          <button
            className={`btn arrow-btn ${
              this.state.valid ? "valid" : "invalid"
            }`}
            disabled={this.state.loading}
          >
            <span>{buttonText}</span>
          </button>

          {this.props.errors.routePlanning && (
            <ErrorList errors={this.props.errors.routePlanning} />
          )}
        </form>

        {Object.values(this.props.locations).every(val => Object.keys(val) < 1) 
        && <div className="info-div container">
          <img src={infoIcon} alt="Info Icon" />
            <p className="sub-title">Double tap on the map to add a location.</p>
        </div>}

        {isTabletOrSmaller && (
          <div id="planning-form-map" className="planning-form-map">
            <MapWrapper {...this.props} />
            {valid && <button
                className="btn arrow-btn valid get-directions" 
                onClick={this.handleSubmit}
              >
                <span>Get Directions</span>
            </button>}

            {valid && <button
              className="mobile-clear-icon"
              onClick={ () => {
                this.props.clearAllLocations();
              } }
              type="button"
            >
              <span>Clear all</span>
              <svg className="icon" aria-hidden="true">
                <use xlinkHref="#close"></use>
              </svg>
            </button>}
          </div>
        )}

         <div className="planning-form-regional-maps">
          <a
              className="forward-title"
              href="https://betterbybike.info/maps-and-guides/regional-cycle-maps/"
              onClick={ (e) => trackLinkClick(e) }
          >
              <div className="planning-form-regional-maps__heading">
                <h3 className="underline-heading">
                    Regional Cycle Maps
                </h3>
                <svg>
                  <use xlinkHref="#right-arrow-go" />
                </svg>
              </div>
              <p>A large number of routes of varying type and length, with maps and info that you can download and take with you.</p>
          </a>
        </div>

        <Footer />
      </div>
    );
  }
}

export default PlanningForm;



// WEBPACK FOOTER //
// ./src/components/PlanningForm.js